var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.content),function(item){return _c('div',{key:item.slug,staticClass:"mb-3",staticStyle:{"margin-top":"-15px"}},[_c('NewsCard',{attrs:{"content":item,"height":150,"elevation":false}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }